<template>
	<div class="search-status">
		<template v-if="!searching && results">
			Showing <span class="search-count">{{ showingTotal }}</span> <template v-if="totalResults">of <span class="search-count">{{ totalResults }}</span></template> Result<template v-if="results.length != 1">s</template>
			<template v-if="searchTerm"> for <span class="search-term">{{ searchTerm | truncate(30) }}</span></template>
		</template>
		<template v-else>Searching...</template>
	</div>
</template>


<script>
	export default {
		props: {
			results: {
				type: [Array, Boolean],
				required: true
			},
			pagination: {
				type: [Object, Boolean],
				required: false,
			},

			searching: {
				type: Boolean,
				required: true
			},

			searchTerm: {
				type: String,
				required: true,
				default: ''
			}
		},

		computed: {
			showingTotal() {
				// if(this.pagination) {
				// 	return this.pagination.current_page *  this.pagination.per_page;
				// }

				return this.results.length;
			},
			totalResults() {
				if(this.pagination) {
					return this.pagination.total;
				}

				return 0;
			}
		}
	}
</script>
